<template>
  <Modal
    class="update-statement__header"
    @close="$emit('close')"
  >
    <header class="modal-header">
      <h2>Update Statement</h2>
    </header>

    <section class="modal-body p-3">
      <SelectV2
        :options="[{key: facility.name, value: facility.name, content: facility.name}]"
        :value="facility.name"
        disabled
      />

      <div class="bt-d-flex bt-justify-content-around border border-rounded mt-3 p-2">
        <FileInput
          type="inline"
          placeholder="Upload Private File"
          accept=".xls,.csv"
          @select="setFacilityFile($event, 'privateFile')"
        />

        <FileInput
          type="inline"
          placeholder="Upload Medicaid Pending File"
          accept=".xls,.csv"
          @select="setFacilityFile($event, 'pendingFile')"
        />
      </div>

      <div class="bt-d-flex bt-align-items-center bt-justify-content-between mt-3">
        <div>
          <ErrorMessages :errors="errors"/>
        </div>
        <div>
          <button
            class="button secondary mr-2"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            class="button primary"
            @click="onUpdate"
          >
            Update
          </button>
        </div>
      </div>
    </section>
  </Modal>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal'
import FileInput from '@/components/inputs/FileInput'
import ErrorMessages from '@/components/ErrorMessages'
import { StatementModule } from '@/store/modules/statement.module'
import { getModule } from 'vuex-module-decorators'
import SelectV2 from '@/components/inputsV2/SelectV2'

@Component({
  components: {
    SelectV2,
    ErrorMessages,
    FileInput,
    Modal
  },
  props: {
    facility: {
      type: Object,
      default: {}
    },
    batchId: {
      type: [Number, String],
      default: ''
    }
  }
})
export default class UpdateStatementModal extends Vue {
  errors = []
  facilityFiles = {
    privateFile: null,
    pendingFile: null
  }
  statementModuleInstance = getModule(StatementModule, this.$store)

  setFacilityFile (file, fieldName) {
    this.facilityFiles[fieldName] = file
  }

  validate () {
    this.errors = []
    if (!this.facilityFiles.pendingFile && !this.facilityFiles.privateFile) {
      this.errors.push('Please at least one file')
    }
    return this.errors.length === 0
  }

  async onUpdate () {
    if (this.validate()) {
      const statements = await this.statementModuleInstance.updateStatements({
        facilityId: this.facility.id,
        ...this.facilityFiles,
        batchId: this.batchId
      })
      this.$emit('update', statements)
    }
  }
}
</script>

<style lang="scss">

</style>
